import type {ReactElement} from 'react';
import React, { useState} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';

interface ConfirmDeleteIconProps {
  className?: string;
  id?: string;
  onDelete(): void;
}

export function ConfirmDeleteIcon({className = '', id = '', ...props}: ConfirmDeleteIconProps): ReactElement {
  const [showConfirmDeleteIcons, setShowConfirmDeleteIcons] = useState(false);
  return (
    <div id={id} className={`flex-h-row ${className}`}>
      {showConfirmDeleteIcons ? (
        <>
          <Icon
            id={`${id}-confirm-delete-icon`}
            onClick={(): void => {
              props.onDelete();
            }}
            className="spacing-m-r-1"
            icon="icon-check"
            type={IconType.GHOST}
            size={IconSize.SIZE_ICON_16}
            shape={IconShape.SQUARE}
          />
          <Icon
            id={`${id}-close-icon`}
            onClick={(): void => {
              setShowConfirmDeleteIcons(false);
            }}
            icon="icon-close"
            type={IconType.GHOST}
            shape={IconShape.SQUARE}
            size={IconSize.SIZE_ICON_16}
          />
        </>
      ) : (
        <Icon
          id={`${id}-delete-icon`}
          onClick={(): void => {
            setShowConfirmDeleteIcons(true);
          }}
          icon="icon-delete"
          className="color-danger-100"
          type={IconType.GHOST_UNCOLORED}
          size={IconSize.SIZE_ICON_16}
          shape={IconShape.SQUARE}
        />
      )}
    </div>
  );
}
